/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoSfrIcon16Light = forwardRef('GovKoSfrIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.658 1.088a.5.5 0 0 1 .129.695l-1.375 2A.5.5 0 0 1 7 4H5a3 3 0 1 0 0 6h.24a.435.435 0 0 0 .365-.2L9.553 3.66c.264-.41.72-.659 1.207-.659H11a4 4 0 0 1 0 8H9.27l-2.277 3.465a.5.5 0 1 1-.836-.55l2.425-3.69A.5.5 0 0 1 9 10h2a3 3 0 1 0 0-6h-.24a.435.435 0 0 0-.365.2L6.447 10.34c-.264.41-.72.659-1.207.659H5a4 4 0 0 1 0-8h1.737l1.226-1.783a.5.5 0 0 1 .695-.129Z" })));
});
